import { Directive } from '@angular/core';

@Directive({
  selector: '[phxHideOnMobile]',
  host: {
    class: 'phx-hide-on-mobile',
  },
})
export class PhxHideOnMobileDirective {}
